import api from '../services/api';

const uploadFileToAPI = async (uploadFile, allowableFileTypes, apiMethod, onSuccess, onError) => {
  const escaped = allowableFileTypes.map((type) => type.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regex = new RegExp(`\\.(${escaped.join('|')})$`, 'i');
  if (!regex.test(uploadFile.name)) {
    onError(`The file selected is not one of the following allowable file types: ${allowableFileTypes}`);
    return;
  }

  const reader = new FileReader();
  reader.onloadend = async () => {
    const body = {
      filename: uploadFile.name,
      size: uploadFile.size,
      type: uploadFile.type,
      csvContents: reader.result,
    };

    try {
      const response = await api(apiMethod, body);
      onSuccess(response);
    } catch (error) {
      const message = 'Error encountered while uploading file.';
      console.error(message, error);
      onError(message);
    }
  };
  reader.readAsText(uploadFile);
};

export default uploadFileToAPI;
